import { render } from "./Traders-services-en.vue?vue&type=template&id=5fee734f&scoped=true"
import script from "./Traders-services-en.vue?vue&type=script&lang=js"
export * from "./Traders-services-en.vue?vue&type=script&lang=js"

import "./Traders-services-en.vue?vue&type=style&index=0&id=5fee734f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fee734f"]])

export default __exports__